module.exports = __webpack_public_path__ + "static/provalindo-chandra-rambey-96c476f260fdddabc3fabb0b75f55cec.png";